import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: 'APP下载', href: '#app' },
  { label: '热门推荐', href: '#cards' },
  { label: '焦点专题', href: '#carousel' },
  { label: '精彩视频', href: '#media' },
  { label: '常见问题', href: '#faq' },
  { label: '热播榜单', href: '#ranking' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 h-[72px] max-w-[1440px] mx-auto">
        <a
          href="#hero"
          className="flex items-center gap-2 text-foreground-950 no-underline shrink-0 cursor-pointer"
        >
          <span className="text-lg font-heading font-bold text-primary-600 whitespace-nowrap">91影视</span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-3 py-2 text-sm whitespace-nowrap text-foreground-700 hover:text-primary-600 transition-colors rounded-md hover:bg-background-100 cursor-pointer no-underline"
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#app"
            className="inline-flex items-center px-5 py-2 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer no-underline"
          >
            <i className="ri-download-line mr-1.5"></i>免费下载
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer bg-transparent border-0"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-[72px] bg-background-50 z-40 animate-[fadeIn_0.2s_ease]">
          <div className="flex flex-col p-4 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="block px-4 py-3 text-foreground-800 hover:bg-background-100 rounded-lg transition-colors text-base cursor-pointer no-underline"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={() => setMobileOpen(false)}
              className="mt-3 mx-4 flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer no-underline"
            >
              <i className="ri-download-line"></i>免费下载
            </a>
          </div>
        </div>
      )}
    </header>
  );
}